import { ComponentProps, type FC } from 'react';
import { formatCurrencyEur } from '../../../../Helper/formatter';
import clsx from 'clsx';

type DepositInfoPropT = {
  unitsCount: number;
  price: number;
  className?: string;
} & ComponentProps<'span'>;

const DepositInfo: FC<DepositInfoPropT> = ({
  unitsCount,
  price,
  className,
  ...props
}) => {
  return (
    <span
      className={clsx(className, 'fw-bold')}
      {...props}
    >{`${unitsCount} x ${formatCurrencyEur(price)}`} Deposit</span>
  );
};

export default DepositInfo;
